import { createContext, useContext } from 'react';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { SerializedError } from '@reduxjs/toolkit';
import { SliderResponse } from '../../../transport/types/SliderResponse';

type UseGetSliderItems = [
    (locale: string) => void,
    {
        isSuccess: boolean;
        isLoading: boolean;
        isError: boolean;
        error?: FetchBaseQueryError | SerializedError;
        data?: SliderResponse;
    }
];

export const UseGetSliderItemsContext = createContext<UseGetSliderItems | undefined>(undefined);

export const useGetSliderItems = () => {
    const contextValue = useContext(UseGetSliderItemsContext);
    if (!contextValue) {
        throw new Error(
            "No useGetSliderItems defined with react context, pls implement: '<UseGetSliderItemsContext.Provider value={[doGetSliderItems, state]}>{children}</UseGetSliderItemsContext.Provider>'"
        );
    }
    return contextValue;
};
